"use strict";
/* tslint:disable:max-line-length */
Object.defineProperty(exports, "__esModule", { value: true });
var string_serialiser_1 = require("./../serialisers/string-serialiser");
var error_report_list_serialiser_1 = require("./../services/error-report-list-serialiser");
var service_definition_1 = require("./../services/service-definition");
var jmx_fetch_request_serialiser_1 = require("./../services/fetch-jmx-values/jmx-fetch-request-serialiser");
var jmx_fetch_response_serialiser_1 = require("./../services/fetch-jmx-values/jmx-fetch-response-serialiser");
var session_metric_collector_list_serialiser_1 = require("./../services/metric-collectors/session-metric-collector-list-serialiser");
var session_metric_collector_serialiser_1 = require("./../services/metric-collectors/session-metric-collector-serialiser");
var topic_metric_collector_list_serialiser_1 = require("./../services/metric-collectors/topic-metric-collector-list-serialiser");
var topic_metric_collector_serialiser_1 = require("./../services/metric-collectors/topic-metric-collector-serialiser");
var measured_entity_class_metrics_serialiser_1 = require("./../services/metrics/measured-entity-class-metrics-serialiser");
var measured_entity_class_request_serialiser_1 = require("./../services/metrics/measured-entity-class-request-serialiser");
var server_metrics_serialiser_1 = require("./../services/metrics/server-metrics-serialiser");
exports.PUT_SESSION_METRIC_COLLECTOR = {
    id: 135,
    request: session_metric_collector_serialiser_1.SessionMetricCollectorSerialiser,
    response: error_report_list_serialiser_1.ErrorReportListSerialiser
};
exports.REMOVE_SESSION_METRIC_COLLECTOR = {
    id: 136,
    request: string_serialiser_1.StringSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.LIST_SESSION_METRIC_COLLECTORS = {
    id: 137,
    request: service_definition_1.NullSerialiser,
    response: session_metric_collector_list_serialiser_1.SessionMetricCollectorListSerialiser
};
exports.GET_SERVER_METRICS = {
    id: 142,
    request: service_definition_1.NullSerialiser,
    response: server_metrics_serialiser_1.ServerMetricsSerialiser
};
exports.GET_MEASURED_ENTITY_CLASS_METRICS = {
    id: 145,
    request: measured_entity_class_request_serialiser_1.MeasuredEntityClassRequestSerialiser,
    response: measured_entity_class_metrics_serialiser_1.MeasuredEntityClassMetricsSerialiser
};
exports.PUT_TOPIC_METRIC_COLLECTOR = {
    id: 146,
    request: topic_metric_collector_serialiser_1.TopicMetricCollectorSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.REMOVE_TOPIC_METRIC_COLLECTOR = {
    id: 147,
    request: string_serialiser_1.StringSerialiser,
    response: service_definition_1.NullSerialiser
};
exports.LIST_TOPIC_METRIC_COLLECTORS = {
    id: 148,
    request: service_definition_1.NullSerialiser,
    response: topic_metric_collector_list_serialiser_1.TopicMetricCollectorListSerialiser
};
exports.FETCH_JMX_VALUES = {
    id: 149,
    request: jmx_fetch_request_serialiser_1.JMXFetchRequestSerialiser,
    response: jmx_fetch_response_serialiser_1.JMXFetchResponseSerialiser
};



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/metrics-services.js
// module id = 1358
// module chunks = 1